<template>
    <i :class="resolvedClass"
       :style="resolvedStyles"
       :data-force-hover="forceHover"
       :data-force-focus="forceFocus"
       :data-force-active="forceActive"
       aria-hidden="true"
    />
</template>

<script setup>
// TODO: This needs to be converted to a DevDash component. To fully integrate with the system design.
import { computed } from "vue";
import { iconRegistry } from "@common/icon/iconRegistry";

const props = defineProps({
    name: String,
    size: String,
    color: String,
    hover: String,
    focus: String,
    active: String,
    forceHover: {
        type: Boolean,
        default: false,
    },
    forceFocus: {
        type: Boolean,
        default: false,
    },
    forceActive: {
        type: Boolean,
        default: false,
    },
});

const sizeClassMap = {
    xs: "--text-size-caption",
    sm: "--text-size-subtitle",
    base: "--text-size-base",
    lg: "--text-size-headline",
    xl: "--text-size-h4",
    '2xl': "--text-size-h3",
    '3xl': "--text-size-h2",
    '4xl': "--text-size-h1",
};

const resolvedStyles = computed(() => {
    const sizeVar = sizeClassMap[props.size] ?? sizeClassMap.lg;

    const styles = {
        fontSize: `var(${sizeVar})`,
        '--icon-color-default': props.color || 'var(--text-color-body)',
    };

    if (props.hover) {
        styles['--icon-color-hover'] = props.hover;
    }
    if (props.active) {
        styles['--icon-color-active'] = props.active;
    }
    if (props.focus) {
        styles['--icon-color-focus'] = props.focus;
    }
    return styles;
});

const resolvedClass = computed(() => iconRegistry[props.name] || props.name);

// TODO: future--deliver messages to developer in dev mode.
// if (process.env.NODE_ENV === 'development') {
//     if (props.name && props.fa) {
//         console.warn(
//             `[Icon] Both 'name' and 'fa' were provided. 'name' takes priority.`
//         )
//     }
//
//     if (!props.name && !props.fa) {
//         console.warn(`[Icon] No icon provided.`)
//     }
// }

</script>

<style scoped>
i {
    color: var(--icon-color-default);
    transition: color 0.2s ease-in-out;
}
i:hover, i[data-force-hover="true"] {
    color: var(--icon-color-hover, var(--icon-color-default));
}

i:active, i[data-force-active="true"] {
    color: var(--icon-color-active, var(--icon-color-default));
}

i:focus, i[data-force-focus="true"] {
    color: var(--icon-color-focus, var(--icon-color-default));
}
</style>
